import { useFeatureValue } from "@growthbook/growthbook-react";

/**
 * Hook to check if the new onboarding flow experiment is enabled
 * @returns boolean indicating if the new onboarding flow is enabled
 */
export function useNewOnboardingFlow(): boolean {
	return useFeatureValue("new-onboarding-flow", false);
}
